import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, EditableDBItemV3, LL_H_C, LL_V_L, ModuleFE_AppConfig, ModuleFE_Dialog, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { ICONS } from '@app/styles';
import './ConfigDialog_SmartDocs_NoteIds.scss';
import { DropDown_NoteTemplate } from '../../../_entity/note-template/ui-components.js';
import { ConfigKey_SmartDocs_NoteIds } from '@app/advisor-content-shared';
export class ConfigDialog_SmartDocs_NoteIds extends ComponentSync {
    // ######################## Static ########################
    static show() {
        const model = {
            dialogKey: ConfigKey_SmartDocs_NoteIds,
            closeOverlayOnClick: () => true,
            content: _jsx(ConfigDialog_SmartDocs_NoteIds, {}),
        };
        ModuleFE_Dialog.show(model);
    }
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state.editable ??= this.getEditable();
        return state;
    }
    // ######################## Logic ########################
    closeDialog = () => {
        ModuleFE_Dialog.close();
    };
    getEditable() {
        const config = ModuleFE_AppConfig.cache.find(config => config.key === ConfigKey_SmartDocs_NoteIds) ?? { key: ConfigKey_SmartDocs_NoteIds, data: {} };
        // @ts-ignore
        const editable = new EditableDBItemV3(config, ModuleFE_AppConfig);
        editable.setAutoSave(true);
        editable.setOnChanged(async () => this.forceUpdate());
        editable.setOnSaveCompleted(() => this.forceUpdate());
        return editable;
    }
    // ######################## Render ########################
    render() {
        return _jsxs(LL_V_L, { id: 'config-dialog__summary-docs__note-ids', className: 'config-dialog', children: [this.render_Title(), this.render_Content()] });
    }
    render_Title = () => {
        return _jsxs(LL_H_C, { className: 'config-dialog__title', children: ["Config Editor - Note IDs", _jsx(ICONS.x.component, { className: 'config-dialog__title-icon', onClick: this.closeDialog })] });
    };
    render_Content = () => {
        const data = this.state.editable.editProp('data', {});
        return _jsxs("div", { className: 'config-dialog__content', children: [_jsx(TS_PropRenderer.Vertical, { label: 'Summary', children: _jsx(DropDown_NoteTemplate.editable, { editable: data, prop: 'summary', canUnselect: true }) }), _jsx(TS_PropRenderer.Vertical, { label: 'MDM', children: _jsx(DropDown_NoteTemplate.editable, { editable: data, prop: 'mdm', canUnselect: true }) })] });
    };
}
//# sourceMappingURL=ConfigDialog_SmartDocs_NoteIds.js.map